export enum AdministrationTabsModel {
  TrainingGroups,
  TrainingCategories,
  MarketingChannels,
  EventOverviewPage,
  TextTemplates
}